import { useState } from 'react';

interface CreateUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (user: { name: string; email: string; password: string; role: string; status: 'Active' | 'Inactive'; walletAddress?: string }) => void;
}

const CreateUserModal: React.FC<CreateUserModalProps> = ({ isOpen, onClose, onCreate }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [status, setStatus] = useState<'Active' | 'Inactive'>('Active');
  const [walletAddress, setWalletAddress] = useState('');

  const handleSubmit = () => {
    onCreate({ name, email, password, role, status, walletAddress });
    setName('');
    setEmail('');
    setPassword('');
    setRole('');
    setStatus('Active');
    setWalletAddress('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading text-2xl mb-4">Create New User</h2>
        <div className="mb-4">
          <label htmlFor="name" className="block gothic-text-silver text-sm font-bold mb-2">Username:</label>
          <input
            type="text"
            id="name"
            className="gothic-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block gothic-text-silver text-sm font-bold mb-2">Email:</label>
          <input
            type="email"
            id="email"
            className="gothic-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="password" className="block gothic-text-silver text-sm font-bold mb-2">Password:</label>
          <input
            type="password"
            id="password"
            className="gothic-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="role" className="block gothic-text-silver text-sm font-bold mb-2">Role:</label>
          <input
            type="text"
            id="role"
            className="gothic-input"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          />
        </div>
        <div className="mb-6">
          <label htmlFor="status" className="block gothic-text-silver text-sm font-bold mb-2">Status:</label>
          <select
            id="status"
            className="gothic-input"
            value={status}
            onChange={(e) => setStatus(e.target.value as 'Active' | 'Inactive')}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        <div className="mb-6">
          <label htmlFor="walletAddress" className="block gothic-text-silver text-sm font-bold mb-2">Wallet Address:</label>
          <input
            type="text"
            id="walletAddress"
            className="gothic-input"
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
          />
        </div>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="gothic-button gothic-button-error mr-2"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="gothic-button gothic-button-primary"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateUserModal;
